import { Box, Button, Stack, Typography } from '@mui/material';
import { OpenCheckImageIconWithoutBackground } from '@icons/OpenCheckImageIconWithoutBackground';
import { refineFonts } from '@/Theming/refineFonts';
import { OpenCheckImageIcon } from '@icons/OpenCheckImageIcon';

interface EnlargeButtonProps {
	onClick: () => void;
	buttonText: string;
}

export const EnlargeButtonWithTextOnImage = ({ onClick, buttonText }: EnlargeButtonProps) => {
	return (
		<Stack
			onClick={onClick}
			sx={{
				gap: '4px',
				alignItems: 'center',
				borderRadius: '48px',
				border: '1px solid var(--Main-Blue-Blue-50, #5770F6)',
				background: '#FFF',
				boxShadow: '0px 0px 6px 0px rgba(15, 21, 47, 0.12), 0px 6px 6px 0px rgba(15, 21, 47, 0.10)',
				flexDirection: 'row',
				backgroundColor: 'white',
				position: 'absolute',
				paddingInline: '8px',
				paddingY: '4px',
				bottom: '5px',
				right: '10px',
				outline: 'none',
				cursor: 'pointer',
				transition: 'transform 0.3s ease-in-out',
				'&:hover': {
					transform: 'scale(1.2)',
					outline: 'none',
					border: '1px solid var(--Main-Blue-Blue-50, #5770F6)',
				},
			}}>
			<OpenCheckImageIconWithoutBackground />
			<Typography sx={{ ...refineFonts.smallRegular, color: '#4657F4' }}>{buttonText}</Typography>
		</Stack>
	);
};

export const EnlargeButtonWithoutTextOnImage = ({ onClick }: EnlargeButtonProps) => {
	return (
		<Box
			onClick={onClick}
			sx={{
				backgroundColor: 'transparent',
				position: 'absolute',
				bottom: '0',
				right: '10px',
				border: 'none',
				outline: 'none',
				cursor: 'pointer',
				transition: 'transform 0.3s ease-in-out',
				'&:hover': {
					transform: 'scale(1.2)',
					outline: 'none',
					border: 'none',
				},
			}}>
			<OpenCheckImageIcon />
		</Box>
	);
};

export const EnlargeButtonWithText = ({ onClick }: EnlargeButtonProps) => {
	return (
		<Button
			onClick={onClick}
			sx={{
				color: '#4657F4',
				...refineFonts.mediumRegular,
			}}
			variant={'text'}
			startIcon={<OpenCheckImageIconWithoutBackground />}>
			Enlarge the check
		</Button>
	);
};
